import React, { ReactNode, useEffect, useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classNames from 'classnames';

import { setTitle } from '~main/actions/login';

export interface Tab {
  id: string;
  title: string;
  component?: React.FC<any>;
  content?: ReactNode;
  authTag?: string;
}

interface ComponentProps {
  tabs: Tab[];
  className?: string;
  setPageTitle?: boolean;
  activeTab?: number;
  onTabChange?: (index: number) => void;
}

const TabContainer: React.FC<ComponentProps> = ({
  tabs,
  className,
  setPageTitle = true,
  activeTab: controlledActiveTab,
  onTabChange,
}) => {
  const [internalActiveTab, setInternalActiveTab] = useState<number>(0);

  const isControlled = controlledActiveTab !== undefined;
  const activeTab = isControlled ? controlledActiveTab : internalActiveTab;

  const handleTabChange = (index: number) => {
    if (isControlled) {
      onTabChange?.(index);
    } else {
      setInternalActiveTab(index);
    }
  };

  const navClassNames = (tabId: number) => classNames({ active: activeTab === tabId });

  const buildNavTabs = () => {
    return tabs.map(({ id, title }, index) => (
      <NavItem key={index}>
        <NavLink data-cy={`${id}-tab`} className={navClassNames(index)} onClick={() => handleTabChange(index)}>
          {title}
        </NavLink>
      </NavItem>
    ));
  };

  const buildTabsContent = () => {
    return tabs.map(({ component, content, title, authTag }, index) => {
      const Component = component;

      return (
        <TabPane key={index} tabId={index}>
          {Component ? (
            <Component isActive={activeTab === index} title={title} authTag={authTag} />
          ) : (
            content
          )}
        </TabPane>
      );
    });
  };

  const outerClassName = classNames('p-2 tab-container', className);

  useEffect(() => {
    if (setPageTitle) setTitle(tabs[activeTab].title);
  }, [activeTab, setPageTitle]);

  return (
    <div className={outerClassName}>
      <Nav tabs>{buildNavTabs()}</Nav>
      <TabContent className="p-2" activeTab={activeTab}>
        {buildTabsContent()}
      </TabContent>
    </div>
  );
};

export default TabContainer;
